/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Metric_Job_CountInputs */



/**
* | output |
* | --- |
* | "Job Count" |
*
* @param {Usage_Metric_Job_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_metric_job_count = /** @type {((inputs?: Usage_Metric_Job_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Metric_Job_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre d'emplois")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der Arbeitsplätze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conteggio dei lavori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество рабочих мест")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recuento de trabajos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("工作数量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブ数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरियों की संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contagem de empregos")
	return /** @type {LocalizedString} */ ("Job Count")
});